import * as SecureStore from 'expo-secure-store';
import { Platform } from 'react-native';

const JWT_TOKEN_KEY = 'vida_jwt_token';
const REFRESH_TOKEN_KEY = 'vida_refresh_token';
const TOKEN_EXPIRES_KEY = 'vida_token_expires';
const LOGIN_RESPONSE_KEY = 'vida_login_response';

export type StoredAuthTokens = {
  token: string;
  refresh?: string;
  expires: string;
};

async function setItem(key: string, value: string): Promise<void> {
  if (Platform.OS === 'web') {
    sessionStorage.setItem(key, value);
    return;
  }
  await SecureStore.setItemAsync(key, value);
}

async function getItem(key: string): Promise<string | null> {
  if (Platform.OS === 'web') {
    return typeof sessionStorage === 'undefined' ? null : sessionStorage.getItem(key);
  }
  return SecureStore.getItemAsync(key);
}

async function removeItem(key: string): Promise<void> {
  if (Platform.OS === 'web') {
    sessionStorage.removeItem(key);
    return;
  }
  await SecureStore.deleteItemAsync(key);
}

export async function storeAuthTokens(tokens: StoredAuthTokens): Promise<void> {
  await setItem(LOGIN_RESPONSE_KEY, JSON.stringify(tokens));
  await setItem(JWT_TOKEN_KEY, tokens.token);
  if (tokens.refresh) {
    await setItem(REFRESH_TOKEN_KEY, tokens.refresh);
  }
  await setItem(TOKEN_EXPIRES_KEY, tokens.expires);
}

export async function getStoredAccessToken(): Promise<string | null> {
  return getItem(JWT_TOKEN_KEY);
}

export async function getStoredRefreshToken(): Promise<string | null> {
  return getItem(REFRESH_TOKEN_KEY);
}

export async function getStoredTokenExpires(): Promise<string | null> {
  return getItem(TOKEN_EXPIRES_KEY);
}

export async function clearStoredAuthTokens(): Promise<void> {
  await Promise.all([
    removeItem(JWT_TOKEN_KEY),
    removeItem(REFRESH_TOKEN_KEY),
    removeItem(TOKEN_EXPIRES_KEY),
    removeItem(LOGIN_RESPONSE_KEY),
  ]);
}
